import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (localStorage.getItem("admin") === "true") {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [navigate]);

  const handleLogin = (e) => {
    e.preventDefault();

    if (
      email === "admin@param.life" &&
      password === "param123"
    ) {
      localStorage.setItem("admin", "true");

      navigate("/admin/dashboard", {
        replace: true,
      });
    } else {
      alert("Invalid Email or Password");
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F1EA] flex items-center justify-center">
      <form
        onSubmit={handleLogin}
        className="bg-white p-10 rounded-3xl shadow-xl w-[420px]"
      >
        <h1 className="text-3xl font-bold text-center mb-2">
          Param CMS
        </h1>

        <p className="text-gray-500 text-center mb-8">
          Admin Login
        </p>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full border p-3 rounded-xl mb-4"
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full border p-3 rounded-xl mb-6"
        />

        <button
          type="submit"
          className="w-full bg-secondary text-white py-3 rounded-xl"
        >
          Login
        </button>
      </form>
    </div>
  );
}